import { styled } from 'goober';
import { forwardRef } from 'react';
import { Pattern, SwatchBorderStyle } from '@common/api';

export const ColorBadgeOuter = styled(
    'div',
    forwardRef
)<{
    $disabled?: boolean;
    $selected?: boolean;
    $round?: boolean;
    $button?: boolean;
}>(({ theme, $disabled, $selected, $round }) => ({
    position: 'relative',

    margin: '1px',
    height: '22px',
    width: '22px',
    border: `1px solid ${theme.colors.neutral.w100}`,
    borderRadius: $round ? '100%' : '6px',
    cursor: $disabled ? 'unset' : 'pointer',
    zIndex: $selected ? 1 : 'unset',
    flexShrink: 0,

    '&:hover':
        !$selected && !$disabled
            ? {
                  outline: `1px solid ${theme.colors.neutral.w400}`,
              }
            : undefined,
    outline: $selected && !$disabled ? `2px solid ${theme.colors.ui.dark}` : undefined,

    '& > div.color-badge-half:nth-child(1)': {
        clipPath: 'polygon(0% 0%, 100% 0%, 0% 100%)',
    },
    '& > div.color-badge-half:nth-child(2)': {
        clipPath: 'polygon(100% 100%, 100% 0%, 0% 100%)',
    },
}));

export const ColorBadgeInner = styled(
    'div',
    forwardRef
)<{
    $color?: string | null;
    $border?: string | null;
    $borderStyle?: SwatchBorderStyle;
    $pattern?: Pattern;
    $round?: boolean;
}>(({ theme, $color, $border, $borderStyle, $pattern, $round }) => ({
    position: 'absolute',
    margin: '0px',
    height: '20px',
    width: '20px',
    borderRadius: $round ? '100%' : '6px',
    border: {
        [SwatchBorderStyle.None]: 'none',
        [SwatchBorderStyle.Thin]: `1px solid ${$border ?? theme.colors.neutral.w100}`,
        [SwatchBorderStyle.Thick]: `2px solid ${$border ?? theme.colors.neutral.w100}`,
    }[$borderStyle ?? SwatchBorderStyle.None],
    background:
        $color != null
            ? $pattern === Pattern.None
                ? 'transparent'
                : $pattern === Pattern.Hatched
                ? `repeating-linear-gradient(-45deg, transparent, transparent 2px, ${$color} 3px, ${$color} 5px, transparent 6px)`
                : $color
            : 'transparent',
}));

export const ColorBadgeBar = styled(
    'div',
    forwardRef
)(({ theme }) => ({
    position: 'absolute',
    left: '9px',
    top: '-1px',
    height: '22px',
    width: '2px',
    transform: 'rotate(45deg)',
    background: theme.colors.ui.white,
}));

export const ColorPickCanvas = styled(
    'div',
    forwardRef
)<{ $width?: number; $height?: number }>(({ $width, $height }) => ({
    position: 'relative',
    width: `${$width}px`,
    height: `${$height}px`,
    borderRadius: '6px',
    overflow: 'hidden',
}));

export const ColorPickBadge = styled(
    'button',
    forwardRef
)<{ $width?: number; $height?: number }>(({ theme, $width, $height }) => ({
    position: 'relative',
    width: `${$width}px`,
    height: `${$height}px`,
    borderRadius: '100%',
    border: `1px solid ${theme.colors.neutral.w100}`,
    cursor: 'pointer',
}));

export const ColorPickSliderKnob = styled(
    'div',
    forwardRef
)({
    marginTop: '1px',
    width: '6px',
    borderRadius: '2px',
    height: '14px',
    boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
    background: '#fff',
    transform: 'translateX(-3px)',
});

export const ColorPickCanvasCircle = styled(
    'div',
    forwardRef
)({
    width: '6px',
    height: '6px',
    boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
    borderRadius: '50%',
    cursor: 'hand',
    transform: 'translate(-3px, -3px)',
});
